import { VehicleModel } from 'app/models/dms/vehicle.model';
import { Component, Input } from '@angular/core';
import { PopoverController, NavController } from '@ionic/angular';
import { ContactResultModel, ContactModel } from 'app/models/dms/contact.model';

@Component({
    template: `
        <ion-list>
          @for (button of buttons; track button) {
            <ion-item (click)="performAction(button)" [class.disabled]="button.disabled">
              <ion-label>{{button.label}}</ion-label>
              @if (button.icon?.startsWith('icon')) {
                <ng-container slot="end">
                  @if (button.icon) {
                    <span class="{{button.icon}}" style="font-size: 26px"></span>
                  }
                </ng-container>
              } @else {
                @if (button.icon) {
                  <ion-icon style="color: var(--ion-color-secondary-tint)" [name]="button.icon"
                  ></ion-icon>
                }
              }
            </ion-item>
          }
        </ion-list>
        `,
    standalone: false
})

export class ModalDetailsPopover
{
    constructor(private popoverCtrl: PopoverController, private navCtrl: NavController)
    {
    }

    @Input() buttons: [];


    async onDismiss()
    {
        try
        {
            await this.popoverCtrl.dismiss();
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }

    async performAction(action: string)
    {
        try
        {
            await this.popoverCtrl.dismiss(action);
        } catch (e)
        {
            //click more than one time popover throws error, so ignore...
        }
    }


    

}